import { Ids } from '../common/ids.model';
import { BrandIdCategoryId } from './brand-id-category-id.model';

export class CompanyStylesFiltersIds {
  public BrandIdCategoryIds: BrandIdCategoryId[];
  public PhotographersIds: Ids[];
  public WarehousesIds: Ids[];

  constructor(init?: Partial<CompanyStylesFiltersIds>) {
    Object.assign(this, init);
  }
}
